import { render, staticRenderFns } from "./LoanGuideLink.vue?vue&type=template&id=3c537d84&scoped=true&"
import script from "./LoanGuideLink.vue?vue&type=script&lang=js&"
export * from "./LoanGuideLink.vue?vue&type=script&lang=js&"
import style0 from "./LoanGuideLink.vue?vue&type=style&index=0&id=3c537d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c537d84",
  null
  
)

export default component.exports